import protoRoot from "../proto-root";
import createMessage from "./createMessage";
import LullabyPlayerState from "../private/LullabyPlayerState";

const name = "lullabyPlayerStateMessage";

function create({ state }) {
  const LullabyPlayerStateMessage = protoRoot.lookupType(
    `comm.LullabyPlayerStateMessage`
  );

  return createMessage({
    [name]: LullabyPlayerStateMessage.create({
      state: LullabyPlayerState.create(state)
    })
  });
}

export default {
  create,
  name
};

// message LullabyPlayerStateMessage {
//   LullabyPlayerState state = 1;
// }
